import React from 'react';
import { styled } from 'linaria/react';
import { HtmlBannerRowItem } from './HtmlBannerRowItem';
import { theme } from '../../../Theme';
import useVisibilitySettings from '../../../../utils/useVisibilitySettings';

const HtmlBannerRowWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${props => props.gap};
  width: 100%;
  max-width: ${props => props.maxwidth};
  margin: auto;

  ${theme.below.lg} {
    flex-direction: column;
  }
`;

export const HtmlBannerRow = ({
  fullWidth,
  gap,
  sweden,
  denmark,
  norway,
  finland,
  netherlands,
  eu,
  children
}) => {
  const visibilitySettings = {
    sweden: sweden?.value,
    denmark: denmark?.value,
    norway: norway?.value,
    finland: finland?.value,
    netherlands: netherlands?.value,
    eu: eu?.value
  };
  const doNotRender = useVisibilitySettings(visibilitySettings);

  const maxWidth = fullWidth?.value ? '100%' : '90rem';
  const elementGap = gap?.value;
  const addedPropsChildren = [];

  // Adds onlyChild prop to each child
  for (const child of children) {
    addedPropsChildren.push(
      <HtmlBannerRowItem
        onlyChild={{ value: children?.length === 1 }}
        {...child.props}
      />
    );
  }

  return (
    <>
      {doNotRender ? null : (
        <HtmlBannerRowWrapper
          className="html-banner-row"
          maxwidth={maxWidth}
          gap={elementGap}
        >
          {addedPropsChildren}
        </HtmlBannerRowWrapper>
      )}
    </>
  );
};
